import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SuperFooterService, EActiveTabStatus, ESupportType, IAttachment } from '../services/super-footer.service';
import { CommonUtil } from '../Utils/common-util';
import { FacilityService } from '../services/facility.service';
import { Subscription } from 'rxjs';
import { AmplitudeAnalyticsService } from '../services/amplitude-analytics.service';

@Component({
  selector: 'app-equipment-question',
  templateUrl: './equipment-question.component.html',
  styleUrls: ['./equipment-question.component.scss'],
})
export class EquipmentQuestionComponent implements OnInit, OnDestroy {
  public activeTabIndex: EActiveTabStatus = EActiveTabStatus.FORM;
  public form: FormGroup;
  public formEditMode: boolean = false;
  public submitted: boolean = false;
  public captchaVarified: boolean = false;
  public attachments: IAttachment[] = [];
  public isInvalidFileFormat: boolean = false;
  public isMaxSizeExcede: boolean = false;

  // subscriptions
  private _facilityOnChange:Subscription;

  // cancel event
  @Output() cancel = new EventEmitter();

  constructor(private service: SuperFooterService, public u: CommonUtil, private _facilityService: FacilityService,
    private _amplitudeService: AmplitudeAnalyticsService) {}

  ngOnInit() {
    this.initForm();
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  changeTab(index: EActiveTabStatus) {
    this.activeTabIndex = index;
  }

  initForm() {
    this.form = this.service.initForm(ESupportType.EQUIPMENT_QUESTION);

    // first time
    this.service.updateDefaultDataToFrom(this.form);

    // when facility change
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.service.updateDefaultDataToFrom(this.form);
    });
  }

  // get fields for form validation message display purpose
  get field() {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;

    // form validation
    if (this.form.invalid) {
      return;
    }

    // if form is valid, then navigate to confirm page
    if (this.activeTabIndex === EActiveTabStatus.FORM) {
      // navigate to confirmation tab
      this.changeTab(EActiveTabStatus.CONFIRMATION);
      return;
    }

    this._amplitudeService.logEvent({elementName: 'Submit', action: 'Click'}, 'Equipment Question');
    // if valid and in confirm page, then submit the form.
    this.service.submit(ESupportType.EQUIPMENT_QUESTION, this.form.value, this.attachments).then(
      (res: any) => {
        this.onReset();
        this.cancel.emit();
      },
      (err: any) => {         
        console.error('API error.')
      }
    );
  }

  onReset() {
    this.submitted = false;
    this.form.reset();
    this.service.updateDefaultDataToFrom(this.form);
    this.attachments = [];
    this.isInvalidFileFormat = false;
    this.isMaxSizeExcede = false;
  }

  onCancel() {
    this.cancel.emit();
  }

  onCaptchaStatusChange(status: string): void {
    this.captchaVarified = status === 'success';
  }

  onFileSelect(event:Event) {
    const { attachments, isInvalidFileFormat, isMaxSizeExcede } = this.service.fileOnChange((<HTMLInputElement>event.target).files);
    this.attachments = attachments;
    this.isInvalidFileFormat = isInvalidFileFormat;
    this.isMaxSizeExcede = isMaxSizeExcede;
  }

  onFileDelete(index:number) {
    this.attachments = this.attachments.filter((item, i) => {
      return index !== i;
    });
  }
}
